export function toStringArray(items) {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => String(item || "").trim())
    .filter(Boolean);
}

export function normalizeOperationalDefinitionState(value) {
  const payload = value && typeof value === "object" ? value : {};
  return {
    metric_name: String(payload.metric_name || payload.metric || "").trim(),
    issue_definition: String(payload.issue_definition || payload.definition || "").trim(),
    counting_rule: String(payload.counting_rule || payload.count_rule || "").trim(),
    measurement_basis: String(payload.measurement_basis || payload.measurement_method || payload.basis || "").trim(),
    validation_notes: toStringArray(payload.validation_notes || payload.notes),
  };
}

export function serializeOperationalDefinitionNotes(notes) {
  return toStringArray(notes).join("\n");
}

export function parseOperationalDefinitionNotes(value) {
  return String(value || "")
    .split("\n")
    .map((item) => item.trim())
    .filter(Boolean);
}

export function hasOperationalDefinitionContent(value) {
  const normalized = normalizeOperationalDefinitionState(value);
  return Boolean(
    normalized.metric_name
      || normalized.issue_definition
      || normalized.counting_rule
      || normalized.measurement_basis
      || normalized.validation_notes.length,
  );
}
